import { useState, useEffect } from 'react'
import useSWR from 'swr'

import { fetchCountriesAndCodes } from 'api/countries'

import type { CommonError, AxiosResponseType } from 'types/api/responses/common'
import type { CountriesResponseType } from 'types/api/responses/countries'

type SystemState = 'active' | 'underMaintenance'

export default function useSystemsState(): SystemState {
	const [systemState, setSystemState] = useState<SystemState>('active')
	const { error } = useSWR<AxiosResponseType<CountriesResponseType>, CommonError>(['/countries'], () =>
		fetchCountriesAndCodes(),
	)

	const isSystemUnderMaintainance = (error: CommonError): boolean => {
		return Boolean(error.error_code && error.error_code === 'maintenance_mode')
	}
	useEffect(() => {
		if (error && isSystemUnderMaintainance(error)) {
			setSystemState(() => 'underMaintenance')
		}
	}, [error])

	return systemState
}
